import React from "react";
import { QRCode } from "react-qr-svg";
import style from "../../assets/jss/disal-main/components/Modal";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(style);

const Modals = ({ id, qrCode, openModal2, handleClose }) => {
  const classes = useStyles();
  
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={openModal2}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
    >
      <Fade in={openModal2}>
        <div className={classes.paper}>
          <div className="modal-dialog" role="document">
            <div className="modal-content ">
              <div className={classes.modalHeader}>
                <button
                  className="btn-close"
                  onClick={handleClose}
                >
                  <span className="closeSpan big"></span>
                </button>
              </div>
              <div
                className="modal-body modalQR"
                style={{
                  textAlign: "center",
                  paddingBottom: "30px"
                }}
              >
                <h4>Codigo QR del punto {id}</h4>
                <QRCode
                  bgColor="#FFFFFF"
                  fgColor="#000000"
                  level="Q"
                  style={{ width: 256 }}
                  value={`${qrCode}`}
                />
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default Modals;
